import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EpButtonType, EpButtonStyle } from '@epicor/kinetic';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { Location } from '@angular/common';
import { QuickOrderLineModel } from '../../models/quick-order-line.model';
import { FieldAgentClient, ProductPrice } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { ProductType } from 'ep-bt-controls';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-molt-negotiation',
  templateUrl: './epbt-fa-quick-order-molt-negotiation.component.html',
  styleUrls: ['./epbt-fa-quick-order-molt-negotiation.component.scss']
})
export class EpbtFaQuickOrderMOLTNegotiationComponent implements OnInit {

  quickOrderLine: QuickOrderLineModel;
  EpButtonType = EpButtonType;
  EpButtonStyle = EpButtonStyle;
  moltNegotiationForm: FormGroup;
  submitted = false;

  @Output() onSaveOrCancelClick = new EventEmitter<any>();

  constructor(public quickOrderService: EpbtFaQuickOrderService,
    private location: Location,
    private client: FieldAgentClient,
    private faService: EpbtFieldAgentService,
    private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit() {

    this.moltNegotiationForm = this.formBuilder.group({
      totalSellPrice: ['', Validators.required],
      description: ['']
    });

    if (!this.quickOrderService.quickOrderLine || !this.quickOrderService.quickOrderLine.Product || !this.quickOrderService.quickOrderLine.ManualOrderLineType) {
      this.location.back();
    }

    if (!this.faService.webTrackUser) {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        this.loadQuickOrderLineData((flag: any) => {
          console.log(flag);
        });
      });
    } else {
      this.loadQuickOrderLineData((flag: any) => {
        console.log(flag);
      });
    }
  }

  patchValues() {
    this.moltNegotiationForm.patchValue({
      totalSellPrice: this.quickOrderService.quickOrderLine.TotalSellPrice,
      description: this.quickOrderService.AddOrEdit ? this.quickOrderService.quickOrderLine.ManualOrderLineType.defaultDescription : this.quickOrderService.quickOrderLine.ManualDescription
    });
  }

  loadQuickOrderLineData(subscribe: (flag: any) => void) {
    if (this.quickOrderService.quickOrderLine && this.quickOrderService.quickOrderLine.Product && this.quickOrderService.quickOrderLine.ManualOrderLineType) {
      this.patchValues();
      subscribe(true);
    }
  }

  updateQuickOrderLineData(subscribe: (flag: any) => void) {
    if (this.moltNegotiationForm.controls['totalSellPrice'].value != this.quickOrderService.quickOrderLine.CurrentStandardUnitSellPrice) {
      this.quickOrderService.quickOrderLine.IsManuallyPriced = true;
    }

    this.quickOrderService.quickOrderLine.TotalSellPrice = this.moltNegotiationForm.controls['totalSellPrice'].value;
    // EDI document reads Manual Charge lines total price from the serialized unit price node
    this.quickOrderService.quickOrderLine.UnitSellPrice = this.moltNegotiationForm.controls['totalSellPrice'].value;
    this.quickOrderService.quickOrderLine.ManualDescription = this.moltNegotiationForm.controls['description'].value;
    subscribe(true);
  }

  // This will be use in html code for validation
  get frmFields() { return this.moltNegotiationForm.controls; }

  onMoltNegotiationSave() {
    this.submitted = true;
    if (this.moltNegotiationForm.invalid || !this.quickOrderService.checkMaxQuantityLimitForRelatedProducts()) {
      return;
    } else {
      this.updateQuickOrderLineData((flag: any) => {

        if (this.quickOrderService.quickOrderLine.ManualDescription) {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.ManualDescription;
        } else {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.Product.description;
        }

        const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
        if (index != -1) {
          this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
        } else {
          this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
        }

        if (this.quickOrderService.selectedRelatedproduct && this.quickOrderService.selectedRelatedproduct.length > 0) {
          const count = 0;
          this.quickOrderService.createRelatedProductOrderLine(count, (flag: boolean) => {
          });
        } else {
          this.router.navigate(['/home/quickorder']);
        }
      });
    }
  }

  onSaveOrCancelSubmit(flag: boolean) {
    // True - Save clicked False - Cancel Clicked
    if (flag) {
      this.onMoltNegotiationSaveForNewOrder((flag: boolean) => {
        this.onSaveOrCancelClick.emit(flag);
      });
    } else {
      this.onSaveOrCancelClick.emit(true);
    }
  }

  onMoltNegotiationSaveForNewOrder(subscribe: (flag: any) => void) {
    this.submitted = true;
    if (this.moltNegotiationForm.invalid) {
      subscribe(false);
    } else {
      this.updateQuickOrderLineData((flag: any) => {

        if (this.quickOrderService.quickOrderLine.ManualDescription) {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.ManualDescription;
        } else {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.Product.description;
        }

        const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
        if (index != -1) {
          this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
        } else {
          this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
        }
        if (!this.quickOrderService.isNewOrder) {
          this.router.navigate(['/home/quickorder']);
        }
        subscribe(true);
      });
    }
  }

  cancelMoltNegotiationClicked() {
    this.router.navigate(['/home/quickorder']);
  }
}
